import { UpsellCardSpotlightComponentProps } from '../../../models/upsell-card-props';
import { ActionButton, DismissButton } from '../../UpsellCardButtons';
import styles from './UpsellCardSpotlightLavender.module.css';

export const UpsellCardSpotlightLavender: React.FC<UpsellCardSpotlightComponentProps> = ({
    title,
    description,
    action,
    dismiss,
    background,
    badge,
    eyebrow,
}) => (
    <s-section padding="none">
        <div
            className={`relative flex h-full flex-col items-center justify-between px-7 py-7 text-center shadow-sm md:card-fix-height ${styles.card}`}
            style={background ? { background } : undefined}
        >
            {dismiss && (
                <div className={'absolute top-2 right-2'}>
                    <DismissButton dismiss={dismiss} />
                </div>
            )}
            {badge && (
                <span className={`mb-2 rounded-md px-2 py-0.5 text-xs font-semibold text-white ${styles.badge}`}>
                    {badge}
                </span>
            )}
            <div className="flex flex-col gap-3 justify-between">
                {eyebrow && <div className={`text-body-sm font-bold uppercase ${styles.eyebrow}`}>{eyebrow}</div>}
                <div className="text-heading-lg font-semibold">{title}</div>
                <div className="mb-4 text-body-md">{description}</div>
            </div>
            {action && <ActionButton action={action} />}
        </div>
    </s-section>
);
